import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Import i18n configuration

// Application Version Timestamp
const APP_VERSION_TIMESTAMP = '2025-12-16T17:04:52Z'; // Development timestamp
console.log('%cApplication Version', 'color: #4CAF50; font-size: 16px; font-weight: bold;');
console.log('%cDeveloped:', 'color: #2196F3; font-weight: bold;', APP_VERSION_TIMESTAMP);
console.log('%cClient Application', 'color: #FF9800; font-size: 14px;');
console.log('%cLoaded:', 'color: #9C27B0; font-weight: bold;', new Date().toISOString());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Temporarily disabled StrictMode to fix message channel error
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
